// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"594":"14e581b5","622":"feb9b9f1","676":"f8e00f6a","959":"ce1f4ec3"}[chunkId] + ".chunk.js";
};